import { h, Component } from 'preact'
import InputGroup from '../ui-components/InputGroup'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../modal'
import ButtonControl from '../button-control'

interface ModalState {
  newName: string
}

interface ModalProps {
  type?: string,
  onSave: (newValue: string) => void,
  onClose: () => void
}

export class EditModal extends Component<ModalProps, ModalState> {
  constructor (props: ModalProps) {
    super(props)
    this.state = {
      newName: props.type || ''
    }
  }

  render ({ type, onSave, onClose }: ModalProps, { newName }: ModalState) {
    return <Modal isOpen size='medium'>
      <ModalHeader title={type ? `Edit event type ${type}` : 'New event type'} onClose={onClose} />
      <ModalBody>
        <InputGroup title='Type name' value={newName} onChange={(e: ChangeEvent) => this.setState({ newName: e.target.value })} />
      </ModalBody>
      <ModalFooter>
        <ButtonControl
          title='Save changes'
          variant='success'
          onClick={() => onSave(newName)} />
        <ButtonControl
          title='Cancel'
          onClick={onClose} />
      </ModalFooter>
    </Modal>
  }
}
